package one.healthium.domain.paywall.models


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable


@Serializable
data class PaywallConfig(
    @SerialName("steps_hidden") val stepsHidden: Boolean? = null,
    @SerialName("background") val background: String? = null,
    @SerialName("content_inset_from_safe_area") val contentInsetFromSafeArea: Boolean? = null,
)